export const DEFAULT_DEBOUNCE_TIME = 250;
export const MENU_TREE_INDENTATION = 24;
export const MENU_DIVIDER_MARGIN_OFFSET = 1.25;
export const MenuNodeTypes = {
  NO_LINK: 'NO_LINK',
  PAGE_LINK: 'PAGE_LINK',
  PAGE_LINK_WITH_PARAMS: 'PAGE_LINK_WITH_PARAMS',
  URL_LINK: 'URL_LINK'
};
export const MenuItemActions = {
  MENU_TREE_ADD_CHILD: 'MENU_TREE_ADD_CHILD',
  MENU_TREE_ADD_NODE: 'MENU_TREE_ADD_NODE',
  MENU_TREE_CLONE_NODE: 'MENU_TREE_CLONE_NODE',
  MENU_NODE_REPLACE: 'MENU_NODE_REPLACE'
};